import React from 'react'

const ListIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    {...props}
  >
    <path
      d='M1.5 6.5H2.5V5.5H1.5V6.5ZM1.5 8.5H2.5V7.5H1.5V8.5ZM1.5 4.5H2.5V3.5H1.5V4.5ZM3.5 6.5H10.5V5.5H3.5V6.5ZM3.5 8.5H10.5V7.5H3.5V8.5ZM3.5 3.5V4.5H10.5V3.5H3.5Z'
      fill='currentColor'
    />
  </svg>
)

export default ListIcon
